import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";

import bindActions from "../../../../helpers/bindActions";
import * as chartActions from "../../../../actions/chartActions";
import { withRouter } from "react-router";

const enhancer = connect(null, bindActions({ chartActions }));

const form = reduxForm({
  form: "selectedTreatmentToComplete",
});

class SelectTreatmentToCompleteNote extends React.Component {
  render() {
    return (
      <Field
        component="textarea"
        className="select-treatment-textarea w-100"
        name="noteArea"
        minRows={2}
        maxRows={2}
        placeholder="Note to Cashier"
      />
    );
  }
}
export default form(enhancer(withRouter(SelectTreatmentToCompleteNote)));
